module.exports = __webpack_public_path__ + "static/media/grap.fe7a98f2.svg";